/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react"
import { Modal, Form, Button, Alert } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { editContact, switchAgency } from "../../../data/contactSlice"
import Loader from "../../../components/Loader"
import { sortAgenciesByName } from "../../../constant/utils"

const ReassignAgencyModal = ({ show, onHide, agencyId, agencies, selectedUser, getAgenciesList }) => {
    const { fetchStatus: contactFetchStatus } = useSelector((state) => state.contact)
    const { fetchStatus: agencyFetchStatus, agencyList } = useSelector((state) => state.agency)

    const [selectedAgencyId, setSelectedAgencyId] = useState("")
    const [filteredAgencies, setFilteredAgencies] = useState([])
    const [validationMessage, setValidationMessage] = useState("")
    const dispatch = useDispatch()

    useEffect(() => {
        const filtered = agencyList?.filter((agency) => agency.id !== agencyId)
        setFilteredAgencies(sortAgenciesByName(filtered))
    }, [show, agencyId, agencies])

    const handleAgencyChange = (e) => {
        setSelectedAgencyId(e.target.value)
        setValidationMessage("")
    }

    const handleAssignClick = () => {
        if (selectedAgencyId === "") {
            setValidationMessage("Please select an agency.")
        } else {
            dispatch(
                switchAgency({
                    id: selectedUser.id,
                    brokerageId: selectedAgencyId
                })
            ).then(({ payload }) => {
                if (payload?.succeeded) {
                    getAgenciesList().then(() => {
                        onHide()
                    })
                } else {
                    onHide()
                }
            })
        }
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Reassign Agency</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Loader show={contactFetchStatus === "loading" || agencyFetchStatus === "loading"} />
                {validationMessage && <Alert variant="danger">{validationMessage}</Alert>}
                <Form>
                    <Form.Group controlId="formUser">
                        <Form.Label>Select Agency</Form.Label>
                        <Form.Select
                            className="form-select-sm"
                            value={selectedAgencyId}
                            required
                            onChange={handleAgencyChange}>
                            <option value={""}>Select Agency</option>
                            {filteredAgencies?.map((agency) => (
                                <option
                                    key={agency.id}
                                    value={agency.id}>
                                    {agency.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn-sm"
                    variant="secondary"
                    onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    className="btn-sm"
                    variant="primary"
                    disabled={selectedAgencyId === "" || validationMessage !== ""}
                    onClick={handleAssignClick}>
                    Assign
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ReassignAgencyModal
